import gql from 'graphql-tag'

export const GET_USERCOUNT_AND_AVATARS = gql`
  query getUsercountAndAvatars {
    randomUserAvatars(first: 20) {
      avatar
    }
    userCount
  }
`
